//通过组件配置路由
import loadable from '../util/loadable'
const routes = [{
    path: '/register/html/black/registerPageload1',
    component: loadable(() => import('../component/registerAndLogin/register/step1/index')) //卖家注册1
}];
export default routes